import { Injectable } from '@angular/core';
/* Model Object which can be passed to Modal service which then can be used
   by Modal's child component
 */
@Injectable()
export class ModalConfig<M = any> {
  data?: M;
}
